var React = require('react');

function Pl (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","key":0},React.createElement("circle",{"cx":"256","cy":"256","r":"256","fill":"#fff"})),React.createElement("g",{"mask":"url(#a)","key":1},[React.createElement("path",{"fill":"#d80027","d":"M0 256l256.4-44.3L512 256v256H0z","key":0}),React.createElement("path",{"fill":"#eee","d":"M0 0h512v256H0z","key":1})])]);
}

Pl.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Pl;

Pl.default = Pl;
